import { connect } from "react-redux";
import VerbundInfoPanel from "./VerbundInfoPanel";

export default connect(state => ({
	master: state.ablauf.master
}))(VerbundInfoPanel);
